export default __webpack_public_path__ + "static/media/undraw_make.b284727a.svg";